import SignUp from "../components/signup.jsx";
import SignUpDetails from "../components/signupDetails.jsx";
import Consents from "../components/consents.jsx";
import ConsultationQuestionnaire from "../components/consultationQuestionnaire.jsx";
import PhotoUpload from "../components/photoUpload.jsx";
import PhotoVerification from "../components/photoVerification.jsx";
import PaymentOrderDetails from "../components/payment/orderDetails.jsx";
import PaymentPaymentDetails from "../components/payment/paymentDetails.jsx";
import PaymentPaymentComplete from "../components/payment/paymentComplete.jsx";
import SelectBBProduct from "../components/selectBBProduct.jsx";
import ScopolamineAddon from "../components/scopolamineAddon.jsx";
import SelectFlavored from "../components/selectBBFlavored.jsx";
import TryFlavored from "../components/selectBBTryFlavored.jsx";
import SelectPharmacy from "../components/selectPharmacy.jsx";
import SubscriptionFollowUpVisitComplete from "../components/subscriptionFollowUpVisitComplete.jsx";
import SleepMembershipDescription from "../components/sleepMembershipDescription.jsx";
import ConfirmShippingDetails from "../components/payment/confirmShippingDetails.jsx";
import ChooseRefillOrderItems from "../components/chooseRefillOrderItems.jsx";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";
// import Fingerprint from "@material-ui/icons/Fingerprint";
// import MonetizationOn from "@material-ui/icons/MonetizationOn";
// import LockOpen from "@material-ui/icons/LockOpen";

const visitRoutes = [
  {
    path: "/visits/:consultationType/signup",
    name: "Register Page",
    short: "Sign Up",
    mini: "SU",
    icon: PersonAdd,
    component: SignUp,
  },
  {
    path: "/visits/:consultationType/signup-details",
    name: "Signup Details",
    short: "Sign Up Details",
    mini: "SUD",
    icon: PersonAdd,
    component: SignUpDetails,
  },
  {
    path: "/visits/consents",
    name: "Telemedicine Consents",
    short: "Consents",
    mini: "TC",
    icon: PersonAdd,
    component: Consents,
  },
  {
    path: "/visits/:consultationType/select-product",
    name: "Select Product",
    short: "Product",
    mini: "SELPROD",
    icon: PersonAdd,
    component: SelectBBProduct,
  },
  {
    path: "/visits/:consultationType/select-pharmacy",
    name: "Select Pharmacy",
    short: "Pharmacy",
    mini: "SELPH",
    icon: PersonAdd,
    component: SelectPharmacy,
  },
  {
    path: "/visits/:consultationType/select-pharmacy-pickup",
    name: "Select Pharmacy Pickup",
    short: "Pharmacy Pickup",
    mini: "SELPHUP",
    icon: PersonAdd,
    component: SelectPharmacy,
  },
  {
    path: "/visits/:consultationType/photo-upload/:photoID",
    name: "Photo Upload",
    short: "Photo Upload",
    mini: "PU",
    icon: PersonAdd,
    component: PhotoUpload,
  },
  {
    path: "/visits/:consultationType/payment/order-details",
    name: "PaymentOrderDetails",
    short: "PaymentOrderDetails",
    mini: "ORDERDETAILS",
    icon: PersonAdd,
    component: PaymentOrderDetails,
  },
  {
    path: "/visits/:consultationType/sca",
    name: "ScopolamineAddon",
    short: "ScopolamineAddon",
    mini: "SCOADDON",
    icon: PersonAdd,
    component: ScopolamineAddon,
  },
  {
    path: "/visits/:consultationType/select-flavored",
    name: "Select Flavored",
    short: "Select Flavored",
    mini: "SELECTFLAVORED",
    icon: PersonAdd,
    component: SelectFlavored,
  },
  {
    path: "/visits/:consultationType/try-flavored",
    name: "Select Flavored Trial",
    short: "Select Flavored Trial",
    mini: "SELECTFLAVOREDTRIAL",
    icon: PersonAdd,
    component: TryFlavored,
  },
  {
    path: "/visits/:consultationType/payment/payment-details",
    name: "PaymentPaymentDetails",
    short: "PaymentPaymentDetails",
    mini: "PAYMENTDETAILS",
    icon: PersonAdd,
    component: PaymentPaymentDetails,
  },
  {
    path: "/visits/:consultationType/payment/complete",
    name: "PaymentComplete",
    short: "PaymentComplete",
    mini: "PAYDONE",
    icon: PersonAdd,
    component: PaymentPaymentComplete,
  },
  {
    path: "/visits/:consultationType/payment",
    pathTo: "/visits/:consultationType/payment/order-details",
    name: "Payment",
    short: "Payment",
    mini: "PAY",
    icon: PersonAdd,
    redirect: true,
  },
  {
    // subscription follow up visit complete - when payment is not required
    path: "/visits/:consultationType/complete",
    name: "SubscriptionFollowUpVisitComplete",
    short: "SubscriptionFollowUpVisitComplete",
    mini: "SUBFOLLOWUPDONE",
    icon: PersonAdd,
    component: SubscriptionFollowUpVisitComplete,
  },

  {
    path: "/visits/:consultationType/photo-verification",
    name: "PhotoVerification",
    short: "PhotoVerification",
    mini: "PV",
    icon: PersonAdd,
    component: PhotoVerification,
  },
  {
    path: "/visits/:consultationType/choose-refill-order-items",
    name: "Choose Refill Order Items",
    short: "Choose Refill Order Items",
    mini: "CHOOSEREFILLORDERITEMS",
    icon: PersonAdd,
    component: ChooseRefillOrderItems,
  },
  {
    path: "/visits/:consultationType/sleep-membership-description",
    name: "SleepMembershipDescription",
    short: "SleepMembershipDescription",
    mini: "SleepMembershipDescription",
    icon: PersonAdd,
    component: SleepMembershipDescription,
  },
  {
    path: "/visits/:consultationType/confirm-shipping-details",
    name: "ConfirmShippingDetails",
    short: "ConfirmShippingDetails",
    mini: "CONFSHIP",
    component: ConfirmShippingDetails,
  },
  {
    path: "/visits/:consultationType/:questionId",
    name: "VisitsConsultation",
    short: "ConsultPA",
    mini: "CPA",
    icon: PersonAdd,
    component: ConsultationQuestionnaire,
  },
  {
    redirect: true,
    path: "/visits/new",
    pathTo: "/visits/pac/signup",
    name: "Register Page",
  },
  {
    redirect: true,
    path: "/visits/signup",
    pathTo: "/visits/pac/signup",
    name: "Register Page",
  },
  {
    redirect: true,
    path: "/visits/pac",
    pathTo: "/visits/pac/1",
    name: "Performance Anxiety Consultation Start",
  },
  {
    redirect: true,
    path: "/visits/inc",
    pathTo: "/visits/inc/1",
    name: "Insomnia Consultation Start",
  },
];

export default visitRoutes;
